import { post } from "@/utils/request";


export default {
    getShareList: query => post("/rrbi/share/getShareList", query),
};